export const STORIES = 'stories'
export const ACTIVITIES = 'activities'
export const DASHBOARD = 'dashboard'
